<template>
  <div>
    <header class="hero-multi">
      <div class="bb-container">
        <div class="hero-multi__container">
          <div class="hero-multi__left">
            <h1 class="hero-multi__title">
              De
              <span class="hero-multi__break">multi-winkel-</span>verlanglijst voor alles wat je wenst
            </h1>
            <div class="hero-multi__actions">
              <bbButton
                label="Maak je verlanglijst"
                class="button--lg button--accent"
                @click="$router.push({ name: 'signup' })"
              />
              <!-- <a
                @click="$router.push({ name: 'guest', params: { id: exampleListId } })"
                class="link link--bold link--underline"
              >
                Ver una lista de ejemplo
              </a> -->
            </div>
          </div>
          <div class="hero-multi__cover">
            <picture>
              <source
                srcset="../../assets/img/covers/cover-fr-hero@2x.png"
                media="(min-width: 1399px) and (min-device-pixel-ratio: 2)"
              />
              <img src="../../assets/img/covers/cover-multi-hero.png" alt="" />
            </picture>
          </div>
        </div>
      </div>
    </header>

    <section class="rate-app">
      <div class="bb-container">
        <div class="rate-app__container">
          <div class="rate-app__title">
            Meer dan 80.000 mensen hebben HelloBB gebruikt om hun wensen te realiseren.
          </div>
          <div class="rate-app__card">
            <div class="rate-app__item">
              <div class="rate-app__logo">
                <img src="../../assets/img/ico/ico-google-play.svg" alt="Google Play" />
              </div>
              <div class="rate-app__rate">4,8</div>
              <div class="rate-app__star">
                <img src="../../assets/img/ico/ico-star-fill.svg" alt="" />
              </div>
            </div>
            <hr />
            <div class="rate-app__item">
              <div class="rate-app__logo">
                <img src="../../assets/img/ico/ico-app-store.svg" alt="Apple App Store" />
              </div>
              <div class="rate-app__rate">4,8</div>
              <div class="rate-app__star">
                <img src="../../assets/img/ico/ico-star-fill.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="tiendas-list">
      <div class="tiendas-list__title">Ontvang elk product uit elke winkel</div>
      <div class="tiendas-list__items">
        <VueSlickCarousel v-bind="shopSlider">
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-amazon.svg" alt="Amazon" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-ikea.svg" alt="IKEA" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-etsy.svg" alt="Etsy" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-sephora.svg" alt="Sephora" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-hm.svg" alt="H & M" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-maisons.svg" alt="Maisons du monde" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-zara.svg" alt="Zara" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-fr-kiavi.svg" alt="Kiavi" />
          </div>
        </VueSlickCarousel>
      </div>
    </section>

    <section class="hbbm-verticales">
      <div class="hbbm-verticales__container bb-container">
        <h3 class="hbbm-verticales__title">
          Perfect voor <span>elke gelegenheid</span>
        </h3>
        <div class="hbbm-verticales__items">
          <VueSlickCarousel v-bind="verticalesSlider" dotsClass="slick-dots">
            <div class="hbbm-verticales__item" v-for="item in verticales" :key="item.name">
              <component
                :is="item.path ? 'router-link' : 'div'"
                :to="item.path || undefined"
                class="hbbm-verticales__content"
              >
                <div class="hbbm-verticales__name">
                  {{ item.name }}
                </div>
                <picture class="hbbm-verticales__image">
                  <img :src="item.cover" :alt="item.name" />
                </picture>
              </component>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </section>

    <section class="app-avanzada">
      <div class="bb-container">
        <div class="app-avanzada__container">
          <aside class="app-avanzada__left">
            <div class="app-avanzada__title">
              De beste verlanglijst-app is <span>gratis</span>
            </div>
            <div class="app-avanzada__description">
              Ontdek onze gratis app met alles wat je nodig hebt om je perfecte verlanglijst te maken.
            </div>
            <div class="app-avanzada__stores" target="_blank">
              <a :href="$t('links.mobileAppUrlAndroid', 'es-ES')">
                <img
                  loading="lazy"
                  src="../../assets/img/logos/logo-app-google.en-GB.svg"
                  alt=""
                  width="140"
                  height="40"
                />
              </a>
              <a :href="$t('links.mobileAppUrlIos', 'es-ES')" target="_blank">
                <img
                  loading="lazy"
                  src="../../assets/img/logos/logo-app-appstore.en-GB.svg"
                  alt=""
                  width="140"
                  height="40"
                />
              </a>
            </div>
          </aside>
          <picture class="app-avanzada__cover">
            <img
              src="../../assets//img/covers/mockup_lista_general_EN.png"
              :alt="'De beste verlanglijst-app is gratis'"
            />
          </picture>
        </div>
      </div>
    </section>

    <main class="home-beneficios">
      <div class="bb-container">
        <div class="home-beneficios__items">
          <section class="home-beneficios__item">
            <div class="home-beneficios__cover">
              <img src="../../assets/img/covers/cover-multi-bolso-iphone.png" alt="" />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                Kies elk product uit elke winkel
              </div>
              <div class="home-beneficios__description">
                Je hebt volledige vrijheid om precies te kiezen wat je wilt.
              </div>
              <ul class="home-beneficios__list">
                <li>Unieke producten van kleine merken</li>
                <li>De beste aanbiedingen van grote winkels</li>
              </ul>
            </div>
          </section>

          <section class="home-beneficios__item">
            <div class="home-beneficios__cover">
              <img
                src="../../assets//img/covers/cover-multi-recibiendo-dinero-002-en.png"
                alt="Ontvang ook geld voor je wensen"
              />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                Ontvang ook geld voor je wensen
              </div>
              <div class="home-beneficios__description">
                Je verlanglijst bevat een digitaal spaarpotje waarin je geld kunt verzamelen voor specifieke aankopen of algemene doelen.
              </div>
              <div class="home-beneficios__actions">
                <div
                  class="link link--bold link--underline"
                  @click="$router.push({ name: 'hucha-de-nacimiento' })"
                >
                  Meer informatie
                </div>
              </div>
            </div>
          </section>

          <section class="home-beneficios__item">
            <div class="home-beneficios__cover">
              <img
                src="../../assets//img/covers/monitorizacion-precios-wishlist-EN.png"
                alt="Koop op het juiste moment"
              />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                Koop op het juiste moment
              </div>
              <div class="home-beneficios__description">
                Wij informeren je wanneer de prijs van je favoriete producten verandert.
              </div>
              <div class="home-beneficios__footnote">
                *Wij volgen uitsluitend prijzen van onze partnerwinkels.
              </div>
            </div>
          </section>
          <section class="home-beneficios__item">
            <div class="home-beneficios__cover home-beneficios__cover--rounded">
              <img
                src="../../assets/img/covers/promos_home.webp"
                alt="Mis nooit meer een aanbieding"
              />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                Mis nooit meer een aanbieding
              </div>
              <div class="home-beneficios__description">
                Sla iets op in je lijst. Begint een van je winkels een actie? Geen probleem, we laten het je weten!
              </div>
              <div class="home-beneficios__actions">
                <a
                  class="link link--bold link--underline"
                  :href="$t('routes.deals', 'nl-NL')"
                >
                  Meer weten
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>

    <div class="feedback-int">
      <div class="bb-container">
        <div class="feedback-int__title">Mooie woorden van onze gebruikers</div>
        <div class="feedback-int__items">
          <VueSlickCarousel v-bind="reviewsSlider">
            <div class="feedback-int__item">
              <div class="feedback-user">
                <div class="feedback-user__cover">
                  <img src="../../assets/img/covers/testimonial-marta.jpg" alt="" />
                </div>
                <div class="feedback-user__content">
                  <div class="feedback-user__string">
                    “Een zeer handige app om cadeaulijsten te maken, of het nu voor de komst van een baby, een doop of een verjaardag is.”
                  </div>
                  <div class="feedback-user__name">Stephanie</div>
                </div>
              </div>
            </div>

            <div class="feedback-int__item">
              <div class="feedback-user">
                <div class="feedback-user__cover">
                  <img src="../../assets/img/covers/testimonial-estefania.jpg" alt="" />
                </div>
                <div class="feedback-user__content">
                  <div class="feedback-user__string">
                    “Precies wat ik zocht. Ik wilde niet beperkt zijn tot slechts één winkel of website voor mijn verlanglijst.”
                  </div>
                  <div class="feedback-user__name">Sarah</div>
                </div>
              </div>
            </div>

            <div class="feedback-int__item">
              <div class="feedback-user">
                <div class="feedback-user__cover">
                  <img src="../../assets/img/covers/testimonial-ichamar.jpg" alt="" />
                </div>
                <div class="feedback-user__content">
                  <div class="feedback-user__string">
                    “Een zeer praktische app om bij te houden wat je nodig hebt, dit naar je contacten te sturen en het budget daarop af te stemmen.”
                  </div>
                  <div class="feedback-user__name">Juan Carlos</div>
                </div>
              </div>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </div>

    <section class="multi-share">
      <div class="bb-container">
        <div class="multi-share__container">
          <article class="multi-share__article">
            <div class="multi-share__title">Deel je wensen eenvoudig</div>
            <div class="multi-share__description">
              Het delen van je lijst is net zo eenvoudig als het kopiëren en plakken van een link. Je familie en vrienden hoeven zich niet te registreren of iets te downloaden.
            </div>
          </article>
          <picture class="multi-share__cover">
            <img
              src="../../assets/img/covers/cover-multi-men-share.png"
              alt="Deel je wensen eenvoudig"
            />
          </picture>
        </div>
      </div>
    </section>

    <section class="cta-yellow-deseos">
      <div class="bb-container">
        <div class="cta-yellow-deseos__cta">
          <div class="cta-yellow-deseos__left">
            <div class="cta-yellow-deseos__title">
              Maak je verlanglijst met je favoriete producten uit elke winkel.
            </div>
            <div class="cta-yellow-deseos__actions">
              <bbButton
                label="Nu starten"
                class="button--accent button--lg"
                @click="$router.push({ name: 'signup' })"
              />
            </div>
          </div>
          <div class="cta-yellow-deseos__cover">
            <img src="../../assets/img/covers/cover-multi-ext-share.png" alt="" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

import bbButton from "../../components/buttons/bbButton.vue";

export default {
  name: "HomeWishlistNL",
  metaInfo() {
    return {
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            name: "HelloBB",
            operatingSystem: [
              //no estic segur del format per posar més d’un valor
              "ANDROID",
              "IOS",
            ],
            applicationCategory: "LifestyleApplication",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "4.5", //no aconsegueixo veure ratings, tu pots?
              ratingCount: "20", //no aconsegueixo veure ratings, tu pots?
            },
            offers: {
              "@type": "Offer",
              price: "0",
            },
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "HelloBB",
            legalName: "HelloBB S.L.",
            url: "https://www.hellobb.net",
            logo: "https://www.hellobb.net/logo-hellobb-dark.svg", //posar URL on tenim el logo
            description:
              "HelloBB-verlanglijst, jouw universele verlanglijst",
            foundingDate: "2022",
            address: {
              "@type": "PostalAddress",
              streetAddress: "C/ Pompeu Fabra 36",
              addressLocality: "Tortosa",
              addressRegion: "Tarragona",
              postalCode: "43500",
              addressCountry: {
                "@type": "Country",
                name: "Spain", //en anglés millor?
              },
            },
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              email: "hola@hellobb.net",
            },
            sameAs: [
              "https://www.instagram.com/holahellobebe/",
              "https://www.facebook.com/holahelloBB",
              "https://www.pinterest.es/holahelloBB/",
              "https://www.crunchbase.com/organization/hellobb",
            ],
          },
        },
      ],
      title: "HelloBB-verlanglijst, jouw universele verlanglijst",
      htmlAttrs: {
        lang: "nl",
      },
      meta: [
        {
          name: "description",
          content:
            "Sla producten op uit elke winkel, verzamel geld, deel eenvoudig … Ontdek waarom HelloBB de nummer 1 verlanglijst-app is.",
        },
        {
          itemprop: "image",
          content: "https://www.hellobb.net/images/cover-portada.08a0882.png",
        },
        {
          property: "og:url",
          content: "https://www.hellobb.net",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:title",
          content: "HelloBB-verlanglijst, jouw universele verlanglijst.",
        },
        {
          property: "og:description",
          content:
            "Sla producten op uit elke winkel, verzamel geld, deel eenvoudig … Ontdek waarom HelloBB de nummer 1 verlanglijst-app is.",
        },
        {
          property: "og:image",
          content: "https://www.hellobb.net/images/cover-portada.08a0882.png",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
        {
          name: "twitter:title",
          content: "HelloBB-verlanglijst, jouw universele verlanglijst.",
        },
        {
          name: "twitter:description",
          content:
            "Sla producten op uit elke winkel, verzamel geld, deel eenvoudig … Ontdek waarom HelloBB de nummer 1 verlanglijst-app is.",
        },
        {
          name: "twitter:image",
          content: "https://www.hellobb.net/images/cover-portada.08a0882.png",
        },
      ],
      link: [
        { rel: "canonical", href: "https://www.hellobb.net/nl" },
        { rel: "alternate", href: "https://www.hellobb.net", hreflang: "es" },
        { rel: "alternate", href: "https://www.hellobb.net/en", hreflang: "en" },
        { rel: "alternate", href: "https://www.hellobb.net/fr", hreflang: "fr" },
        { rel: "alternate", href: "https://www.hellobb.net/it", hreflang: "it" },
        { rel: "alternate", href: "https://www.hellobb.net/nl", hreflang: "nl" },
        { rel: "alternate", href: "https://www.hellobb.net/de", hreflang: "de" },
        { rel: "alternate", href: "https://www.hellobb.net/pt", hreflang: "pt" },
        { rel: "alternate", href: "https://www.hellobb.net", hreflang: "x-default" }
      ]
    };
  },
  components: {
    bbButton,
    VueSlickCarousel,
  },
  data() {
    return {
      verticales: [
        { name: "Geboortelijst", cover: "/cover-hbbm-mujer-cuna.jpg" },
        { name: "Huwelijkslijst", cover: "/cover-hbbm-wedding.jpg" },
        { name: "Verjaardagsverlanglijst", cover: "/cover-hbbm-globos.jpg" },
        { name: "Kerstlijst", cover: "/cover-hbbm-navidad.jpg" },
        {
          name: "Babyshowerlijst",
          cover: "/cover-hbbm-babby-shower.jpg",
        },
        { name: "Housewarming-cadeaulijst", cover: "/cover-hbbm-nueva-casa.jpg" },
      ],
      verticalesSlider: {
        slidesToShow: 4,
        arrows: false,
        autoplay: true,
        dots: false,
        slidesToScroll: 1,
        centerMode: true,
        speed: 900,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            variableWidth: true,
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              dots: true,
            },
          },
        ],
      },
      shopSlider: {
        slidesToShow: 8,
        arrows: false,
        autoplay: true,
        dots: false,

        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "20px",
        edgeFriction: 0.35,
        speed: 500,
        responsive: [
          {
            breakpoint: 1000000,
            settings: {
              slidesToShow: 8,
              // variableWidth: true,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            variableWidth: true,
            breakpoint: 767,
            settings: {
              // autoplay: false,
              slidesToShow: 2,
              variableWidth: true,
            },
          },
        ],
      },
      reviewsSlider: {
        slidesToShow: 3,
        arrows: false,
        autoplay: true,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              centerMode: true,
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
  computed: {
    exampleListId() {
      return process.env.PREVIEW_LIST_ES_ID;
    },
  },
};
</script>

<style lang="scss" scoped></style>
